import React, { useEffect } from "react";
import { Form } from "semantic-ui-react";
import { useTranslation } from "ceco-polyglot";
import es from "date-fns/locale/es";
import { format } from "date-fns";
import { DateRangePicker } from "cecodatepicker";
import { Calendar, Close } from "ceicons";
import DropdownCategories from "../../components/DropdownCategories";
import DropdownUsers from "../../components/DropdownUsers";
import graphql from "babel-plugin-relay/macro";
import createQueryRenderer from "../../helpers/createQueryRenderer";
import "react-datepicker/dist/react-datepicker.css";
import "cecodatepicker/semantic/dist/components/input.css";
import { filter } from "lodash";

import "./filtersRecipes.scss";

export const FiltersRecipes = (props) => {
  const {
    filters,
    setFilters,
    setSidebarActiveCount,
    allCategories,
    allUsers,
  } = props;

  useEffect(() => {
    setSidebarActiveCount(filter(filters).length);
  }, [filters, setSidebarActiveCount]);

  const handleChangeStartDate = (startDate) => {
    setFilters({
      ...filters,
      dateFilter: {
        ...filters.dateFilter,
        startDateTime: startDate,
        startDate: format(startDate, "yyyy/MM/dd"),
      },
    });
  };
  const handleChangeEndDate = (endDate) => {
    setFilters({
      ...filters,
      dateFilter: {
        ...filters.dateFilter,
        endDateTime: endDate,
        endDate: format(endDate, "yyyy/MM/dd"),
      },
    });
  };

  const handleChangeUser = (e, { value }) => {
    setFilters({
      ...filters,
      author: value ? value : null,
    });
  };
  const handleChangeCategory = (e, { value }) => {
    setFilters({
      ...filters,
      category: value ? value : null,
    });
  };
  const handleChangeTrend = (e, { checked }) => {
    setFilters({
      ...filters,
      isTrend: checked ? true : null,
    });
  };

  const t = useTranslation();
  return (
    <Form className="filters-container">
      <Form.Field>
        <label>{t("form.date")}</label>

        <DateRangePicker
          startDate={filters.dateFilter?.startDateTime}
          endDate={filters.dateFilter?.endDateTime}
          onStartChange={handleChangeStartDate}
          onEndChange={handleChangeEndDate}
          className="date-field"
          locale={es}
          inputProps={{
            icon: filters?.dateFilter ? (
              <span
                className="delete-field"
                onClick={() => setFilters({ ...filters, dateFilter: null })}
              >
                <Close />
              </span>
            ) : (
              <Calendar />
            ),
            labelPosition: "right",
          }}
          onFocus={(e) => (e.target.readOnly = true)}
          clearable
          monthsShown={1}
        />
      </Form.Field>

      <Form.Field>
        <DropdownUsers
          formData={filters}
          allUsers={allUsers}
          handleChangeUser={handleChangeUser}
        />
      </Form.Field>

      <Form.Field>
        <DropdownCategories
          formData={filters}
          allCategories={allCategories}
          handleChangeCategory={handleChangeCategory}
        />
      </Form.Field>

      <Form.Field className="isTrend">
        <label>{t("form.trend")}</label>
        <Form.Checkbox
          toggle
          value={filters.isTrend}
          onChange={handleChangeTrend}
          // label={t("form.trend")}
          name="trend"
        />
      </Form.Field>
    </Form>
  );
};
export default createQueryRenderer(FiltersRecipes, {
  query: graphql`
    query FiltersRecipes_Query {
      allUsers(isStaff: true) {
        ...DropdownUsers_allUsers
      }
      allCategories {
        ...DropdownCategories_allCategories
      }
    }
  `,
  // prepareVariables: ({ id }) => ({ id }),
});
